///// <reference path="../../../../etc/typedefinitions/tsd.d.ts" />
/// <reference path="../../../../typings/index.d.ts" />
module Meevo.Plugins.LocationGroups {
    angular.module("meevo.plugins.locationGroups", []);
}